import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';

export let selectMobileDevice = mutatorAction('selectMobileDevice', (index: number) => {
    let store = mobileDeviceFullStore();
    store.selected = index;
});
